import { useEffect } from "react";
import type { RefObject } from "react";
import { blurActiveElement } from "@/shared/lib/blurActiveElement";

/** 다이얼로그 열림 시 blur 로 키보드를 내린 뒤 컨테이너로 focus 이동 — 키보드 위에 팝업이 겹치는 현상 방지(제스처 없이 뜨는 타이머·API 에러 팝업 포함). 닫을 때 포커스는 복원하지 않는다(표준 a11y 와 의도적으로 다름 — 이유·재검토 조건은 ADR 260729-05). ⚠️ blur 가 focus 보다 먼저여야 한다 — iOS 는 키보드로 축소된 viewport 상태에서 fixed 요소에 focus 하면 viewport 가 움직인다. preventScroll 은 보조 옵션(Safari 14.1 에선 무시돼도 예외 없음). */
export function useDialogFocusOnOpen(
  isActive: boolean,
  ref: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    if (!isActive) return;
    blurActiveElement();
    ref.current?.focus({ preventScroll: true });
  }, [isActive, ref]);
}
